import anime from "animejs/lib/anime.es.js";

const animateAccordionContent = (el, dropdownContent, targetHeight, opening) => {
    anime({
        targets: dropdownContent,
        height: targetHeight,
        duration: 500,
        easing: "cubicBezier(0.42, 0.0, 0.58, 1.0)", //ease-in-out
        begin: () => {
            el.classList.add("--animating");

            if (!opening) {
                el.classList.remove("--open");
            }
        },
        complete: () => {
            el.classList.remove("--animating");

            if (opening) {
                el.classList.add("--open");
                dropdownContent.style.height = "auto";
            }
        },
    });
};

const openAccordion = (el) => {
    let targetHeight = el.querySelector(".accordion-inner-content").offsetHeight;

    let dropdownContent = el.querySelector(".accordion-content");

    animateAccordionContent(el, dropdownContent, targetHeight, true);
};

const closeAccordion = (el) => {
    const dropdownContent = el.querySelector(".accordion-content");

    let targetHeight = el.querySelector(".accordion-inner-content").offsetHeight;
    dropdownContent.style.height = targetHeight + "px";

    animateAccordionContent(el, dropdownContent, 0, false);
};

const handleClick = (event) => {
    const item = event.target;

    const parentEl = item.closest(".accordion-container");

    // close every open accordion
    parentEl.querySelectorAll(".accordion").forEach((item) => {
        if (item.classList.contains("--open")) {
            closeAccordion(item);
        }
    });

    const targetAccordion = item.closest(".accordion");

    if (!targetAccordion.classList.contains("--animating")) {
        if (targetAccordion.classList.contains("--open")) {
            closeAccordion(targetAccordion);
        } else {
            openAccordion(targetAccordion);
        }
    }
};

const enableAccordions = (parentSection) => {
    parentSection.querySelectorAll(".accordion").forEach((item) => {
        item.querySelector(".accordion-opener").addEventListener("click", handleClick);

        item.querySelector(".accordion-content").style.height = 0;

        if (item.classList.contains("--expanded")) openAccordion(item);
    });
};

const disableAccordions = (parentSection) => {
    parentSection.querySelectorAll(".accordion").forEach((item) => {
        item.classList.remove("--open");

        item.querySelector(".accordion-opener").removeEventListener("click", handleClick);

        item.querySelector(".accordion-content").removeAttribute("style");
    });
};

export { enableAccordions, disableAccordions };
